import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { map } from 'rxjs/operators';
import { Mission } from 'src/app/shared/models/mission/mission';
import { ConstantsService } from '../../constant/constants.service';
import { GenericCrudService } from '../../generic-crud.service';

@Injectable({
	providedIn: 'root'
})
export class MissionService {
	constructor(
		private appConstants: ConstantsService,
		private genericCrudService: GenericCrudService
	) {}

	/**
	 * Renvoie les missions entre deux dates et avec le plannerId indiqué pour le centre indiqué
	 *
	 * @param startDate
	 * @param endDate
	 * @param plannerId
	 */
	getAllMissionsOfProjectManagerByDateformationBetween(
		startDate: Date,
		endDate: Date,
		plannerId: number,
		centerId: number
	): Observable<Mission[]> {
		if (startDate === null || endDate === null) {
			return null;
		}
		if (startDate.getTime() > endDate.getTime()) {
			[startDate, endDate] = [endDate, startDate];
		}

		let queryParams = new HttpParams();
		queryParams = queryParams.append('start', startDate.getTime());
		queryParams = queryParams.append('end', endDate.getTime());
		queryParams = queryParams.append('plannerId', plannerId);
		queryParams = queryParams.append('centerId', centerId);

		const httpOptions = {
			params: queryParams
		};

		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.missionUrl}`,
			'getAllMissionsOfProjectManagerByDateformationBetween',
			httpOptions
		);
	}

	putMission(mission: Mission): Observable<void> {
		return this.genericCrudService.genericPutDataToAPI(
			`${this.appConstants.missionUrl}`,
			`putMission`,
			mission
		);
	}

	putIntervenantForRecurringMultipleEmployeeEvent(
		numberOfEmployees: number,
		all: boolean,
		next: boolean,
		mission: Mission
	): Observable<void> {
		const params = new HttpParams().set('all', all).set('next', next);

		return this.genericCrudService.genericPutDataToAPI(
			`${this.appConstants.missionWithMultipleEmployeeUrl}/employees/${numberOfEmployees}`,
			`postMissionWithMultipleEmployee`,
			mission,
			{ params: params }
		);
	}

	deleteRecurringMultipleEmployeeEvent(
		all: boolean,
		next: boolean,
		date: Date,
		missionRequestId: number
	): Observable<void> {
		const params = new HttpParams()
			.set('all', all)
			.set('next', next)
			.set('date', new Date(date).getTime());

		return this.genericCrudService.genericDeleteAPIDataByID(
			`${this.appConstants.missionWithMultipleEmployeeUrl}/delete/${missionRequestId}`,
			`postMissionWithMultipleEmployee`,
			{ params: params }
		);
	}

	postMission(mission: Mission): Observable<void> {
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.missionUrl}`,
			`postMission`,
			mission
		);
	}

	postMissionWithIdDemandDH(
		mission: Mission,
		idDemandDH: string
	): Observable<void> {
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.missionUrl}/dh/${idDemandDH}`,
			`postMissionWithIdDemandDH`,
			mission
		);
	}

	postMissionWithMultipleEmployee(
		listMission: Mission[],
		empIdMap: Map<number, boolean>
	): Observable<void> {
		const empIdObj = Object.fromEntries(empIdMap);
		// return this.genericCrudService.genericPostDataToAPI(
		// 	`${this.appConstants.missionWithMultipleEmployeeUrl}/${empIdList}`,
		// 	`postMissionWithMultipleEmployee`,
		// 	listMission
		// );

		return this.genericCrudService.genericPostDataToAPI(
			this.appConstants.missionWithMultipleEmployeeUrl,
			'postMissionWithMultipleEmployee',
			{
				missionList: listMission,
				employeeMap: empIdObj
			}
		  );
	}

	postMissions(missions: Mission[]): Observable<void> {
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.missionUrl}s`,
			`postMissions`,
			missions
		);
	}

	postPrescription(
		mission: Mission,
		prescriberRequestId: string
	): Observable<void> {
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.missionUrl}/prescription/${prescriberRequestId}`,
			`postPrescription`,
			mission
		);
	}

	postPrescriptionWithAssignation(
		mission: Mission,
		prescriberRequestId: string,
		employeeId: number
	): Observable<void> {
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.missionUrl}/prescription/${prescriberRequestId}/force/${employeeId}`,
			`postPrescription`,
			mission
		);
	}

	copyMissionToDates(
		dates: Date[],
		missionRequestId: number
	): Observable<void> {
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.missionUrl}/copy/${missionRequestId}`,
			`copyMissionToDates`,
			dates
		);
	}

	postMissionWithAssignation(
		mission: Mission,
		employeeId: number
	): Observable<void> {
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.missionUrl}/force/${employeeId}`,
			`postMissionWithAssignation`,
			mission
		);
	}

	postMissionWithAssignationAndIdDemandDH(
		mission: Mission,
		employeeId: number,
		idDemandDH: string
	): Observable<void> {
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.missionUrl}/force/${employeeId}/dh/${idDemandDH}`,
			`postMissionWithAssignationAndIdDemandDH`,
			mission
		);
	}

	/**
	 * Envoie une liste de mission à sauvegarder et à affecter
	 * @param missions liste de missions
	 * @param employeeId id de l'employee a qui affectée les missions
	 * @returns
	 */
	postMissionsForceAffectation(
		missions: Mission[],
		employeeId: number,
		startFromHome: boolean
	): Observable<void> {
		/*return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.missionUrl}s/force/${employeeId}`,
			`postMissionsForceAffectation`,
			missions
		);*/
		console.log('📤 Envoi missions au backend (force affectation)');
		console.log('➡️ URL :', `${this.appConstants.missionUrl}s/force/${employeeId}/${startFromHome}`);
		console.log('➡️ Payload :', missions);

		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.missionUrl}s/force/${employeeId}/${startFromHome}`,
			`postMissionsForceAffectation`,
			missions
		).pipe(
			tap({
				next: () => console.log('✅ Envoi réussi vers le backend'),
				error: err => console.error('❌ Erreur lors de l’envoi', err)
			})
		);
	}

	postMissionsForceAffectationAndIdDemandDH(
		missions: Mission[],
		employeeId: number,
		idDemandDH: string
	): Observable<void> {
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.missionUrl}s/force/${employeeId}/dh/${idDemandDH}`,
			`postMissionsForceAffectationAndIdDemandDH`,
			missions
		);
	}

	resetAllMissions(userId: number, solutionId: number): Observable<any> {
		const form: FormData = new FormData();
		form.append('userId', userId.toString());
		form.append('solutionId', solutionId.toString());
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.missionUrl}/reset`,
			`resetAllMissions`,
			form
		);
	}

	changeMissionPlanning(
		missionId: number,
		newPlanningId: number,
		plannerId: number
	): Observable<void> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.missionUrl}/${missionId}/planning/${newPlanningId}/planner/${plannerId}`,
			`changeMissionPlanning`
		);
	}

	/**
	 * === changeMissionPlanning mais à partir de l'id employé au lieu de Id planning
	 */
	changeMission(
		missionId: number,
		newEmployeeId: number,
		plannerId: number
	): Observable<void> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.missionUrl}/${missionId}/employee/${newEmployeeId}/planner/${plannerId}`,
			`changeMission`
		);
	}

	changeVehicule(mission: Mission, newVehiculeId: number): Observable<void> {
		return this.genericCrudService.genericPutDataToAPI(
			`${this.appConstants.missionUrl}/vehicule/${newVehiculeId}`,
			`changeVehicule`,
			mission
		);
	}

	deleteVehicule(missionId: number): Observable<void> {
		return this.genericCrudService.genericDeleteAPIDataByID(
			`${this.appConstants.missionUrl}/${missionId}/vehicule`,
			`deleteVehicule`
		);
	}

	desaffecter(idMission: number) {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.missionUrl}/desaffecter/${idMission}`,
			'desaffecter'
		);
	}

	swapMissions(missionId1: number, missionId2: number): Observable<Mission[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.missionUrl}/${missionId1}/swap/${missionId2}`,
			'swapMissions'
		);
	}

	forceAssignation(
		missionId: number,
		idFromMissionToGetRouteFrom: number
	): Observable<any> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.missionUrl}/${missionId}/assign/${idFromMissionToGetRouteFrom}/forced`,
			'forceAssignation'
		);
	}

	cancelMissionByMissionId(missionId: number, reason: string): Observable<any> {
		return this.genericCrudService.genericPatchDataToAPI(
			`${this.appConstants.missionUrl}/${missionId}/cancel/${reason}`,
			`cancelMissionByMissionId`,
			null
		);
	}

	cancelMissionByMissionIdByMissionRequestId(
		missionRequestId: number,
		reason: string
	): Observable<any> {
		return this.genericCrudService.genericPatchDataToAPI(
			`${this.appConstants.missionUrl}/formation/${missionRequestId}/cancel/${reason}`,
			`cancelMissionByMissionIdByMissionRequestId`,
			null
		);
	}

	undoCancelMissionByMissionRequestId(
		missionRequestId: number
	): Observable<any> {
		return this.genericCrudService.genericPatchDataToAPI(
			`${this.appConstants.missionUrl}/formation/${missionRequestId}/cancel/reset`,
			`undoCancelMissionByMissionRequestId`,
			null
		);
	}

	undoCancelMissionByMissionId(missionId: number): Observable<any> {
		return this.genericCrudService.genericPatchDataToAPI(
			`${this.appConstants.missionUrl}/${missionId}/cancel/reset`,
			`undoCancelMissionByMissionId`,
			null
		);
	}

	updateMissionOrder(listMission: Mission[]): Observable<void> {
		return this.genericCrudService.genericPatchDataToAPI(
			`${this.appConstants.missionUrl}/reorder`,
			`updateMissionOrder`,
			listMission
		);
	}
}
